import { render, staticRenderFns } from "./TreatmentDwellTimeTable.vue?vue&type=template&id=0b578078"
import script from "./TreatmentDwellTimeTable.vue?vue&type=script&lang=js"
export * from "./TreatmentDwellTimeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports